import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class AuthService {
  constructor(
    private storage: StorageService,
    private router: Router
  ) { }


  canActivate(): boolean {
    let canActivate = false;
    if (!this.storage.get('loggedIn')) {
      this.router.navigate(['login']);
      canActivate= false;
    }
    canActivate = true;
    console.log("canActivate",canActivate);
    return canActivate;
  }
}
